class Sources
    constructor: (el) ->
        @.$el = el
        @.$toggleButton = @.$el.querySelector '.sources__toggle'

        @.open = @.$el.classList.contains 'sources--open'

        @.InitEvents()
        @.$el.classList.add 'sources--bound'
        return

    InitEvents: ->
        self = @
        @.$toggleButton.addEventListener 'click', (e) ->
            self.ToggleOpen()
            return
        @.$el.addEventListener 'sources-toggle-open', (e) ->
            self.ToggleOpen()
            return
        return

    ToggleOpen: ->
        @.open = !@.open
        @.$el.classList.toggle 'sources--open'
        return

BindSources = ->
    document.querySelectorAll '.sources:not(.sources--bound)'
        .forEach (el) ->
            new Sources el
            return
    return

window.addEventListener 'bind-components', BindSources